module.exports = __webpack_public_path__ + "img/Walk in.d1c50e54.jpg";